import React, { useState } from "react";
import SecondaryButton from "../../common/buttons/SecondaryButton";

export default function FilterPopup({
  isOpen,
  onClose,
  items,
  selected,
  setSelected,
  applyFilters,
  isApplyFilters,
  setApplyFilters,
}) {
  console.log("items", items);
  const toggleSelection = (trialID) => {
    if (isApplyFilters) {
      setApplyFilters(false);
    }

    setSelected((prev) =>
      prev.includes(trialID)
        ? prev.filter((x) => x !== trialID)
        : [...prev, trialID]
    );
  };

  const toggleSelectAll = () => {
      if (isApplyFilters) {
      setApplyFilters(false);
    }
    if (selected.length === items.length) setSelected([]);
    else setSelected(items.map((i) => i.trialID));
  };

  if (!isOpen) return null;

  return (
    <div className="absolute left-20 top-[150px] z-50">
      <div className="bg-white border rounded-xl shadow-xl w-[338px]">
        <h2 className="text-md font-medium px-3 py-3 rounded-t-xl bg-[#F9FAFB] ">
          Filter Conversation
        </h2>

        {selected.length > 0 && (
          <div className="flex justify-between text-sm px-3 py-3 ">
            <span className="text-[#245CEA]">
              {selected.length} filters selected
            </span>
            {isApplyFilters && (
              <button
                className="text-[#245CEA] font-bold"
                onClick={() => {
                  setSelected([]);
                  setApplyFilters(false);
                }}
              >
                Clear All
              </button>
            )}
          </div>
        )}

        <div className="space-y-2 max-h-[50vh] overflow-y-auto thin-scroll">
          <label className="flex items-center gap-2 p-2 px-4 border-y cursor-pointer select-none">
            <input
              type="checkbox"
              className="accent-[#245cea] border-[#1A1A1B] w-[14px] h-[14px]"
              checked={selected.length === items.length}
              onChange={toggleSelectAll}
            />
            <span className="font-medium">Select All</span>
          </label>

          {items.map((item) => (
            <label
              key={item.trialID}
              className="flex items-center gap-2 p-2 px-4 hover:bg-gray-50 rounded-xl cursor-pointer select-none"
            >
              <input
                type="checkbox"
                className="accent-[#245cea] border-[#1A1A1B] w-[14px] h-[14px]"
                checked={selected.includes(item.trialID)}
                onChange={() => toggleSelection(item.trialID)}
              />
              <span className="font-medium">{item.trialName}</span>
            </label>
          ))}
        </div>

        <div className="flex justify-between pt-4 pl-4 pb-3 bg-[#F9FAFB] rounded-b-xl">
          <SecondaryButton
            label="Cancel"
            onClick={onClose}
            classes="w-[140px] bg-white"
          />
          <button
            onClick={selected.length > 0 ? applyFilters : () => {}}
            className=" btn-primary-base-bar primary_btn flex items-center bg-[#245CEA] text-white py-2 px-5 rounded-[5px] hover:bg-white border hover:border-[#245CEA] hover:text-[#1A1A1B] transition duration-300 h-[42px] text-[16px] font-mont font-[600] mr-5 w-[140px] justify-center"
          >
            Apply Filter
          </button>
        </div>
      </div>
    </div>
  );
}
